import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { configs } from '../constants/configs/configs';

const resetPasswordRoutes = [configs.routes.RESET_PASSWORD, configs.routes.RESET_PASSWORD_SUCCESS];

const useResetPasswordFlow = () => {
    const location = useLocation();

    const isIDResetPasswordFlow = useMemo(() => {
        return resetPasswordRoutes.includes(location.pathname);
    }, [location.pathname]);

    return {
        isIDResetPasswordFlow,
    };
};

export default useResetPasswordFlow;
